import React, { useState, useEffect } from 'react';

import Loader from "components/Loader/Loader";

const Tables = () => {

  const [loading, setLoading] = useState(false);



  return (
      <div className="10">
        <Loader show={loading}/>

      </div>
  );
};

export default Tables;
